import { DeleteAction, EditAction } from "@/components/Action";
import StatusComponent from "@/components/Status";
import { DATE_FORMAT, UserStatus } from "@/constants/default";
import { usePermissions } from "@/rbac";
import { permissions } from "@/rbac/permissions";
import { TransactionType } from "@/types/transactiontype.type";
import { formatDateTimeAutoToString } from "@/utils/format";
import { ColumnDef } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

export default function TableHeader(): ColumnDef<TransactionType>[] {
    const {t} = useTranslation();
    const { hasPermission } = usePermissions();
    const navigate = useNavigate()
    const location = useLocation()

    return [
        {
            header: t("table.name"),
            accessorKey: "name"
        },
        {
            header: t("table.status"),
            accessorKey: "status",
            enableSorting: false,
            cell: ({ row }) => <StatusComponent status={row.original.status} title={UserStatus(row.original.status)} />
        },
        {
            header: t("table.created_at"),
            accessorKey: "created_at",
            cell: ({ row }) => formatDateTimeAutoToString(row.original.created_at, DATE_FORMAT)
        },
        {
            header: t("table.action"),
            accessorKey: "action",
            enableSorting: false,
            cell: ({ row }) => (
                <div className="flex items-center space-x-3.5">
                    {
                        hasPermission(permissions.TRANSACTIONTYPE.EDIT) && <EditAction onClick={() => navigate(location , {state: {modal: "/settings/transaction-types/edit", id: row.original.id}})} />
                    }
                    {
                        hasPermission(permissions.TRANSACTIONTYPE.DELETE) && <DeleteAction onClick={() => navigate(location , {state: {modal: "/settings/transaction-types/delete", id: row.original.id}})} />
                    }
                </div>
            )
        }
    ]
}